LS.util.route({
	'account': {
		'$guard:eval': {
			'listings': {
				'$num': {
					'edit': {
						':load': 'account-post',
						':unload': 'account-post:unload'
					}
				},
				'create': {
					':load': 'account-post',
					':unload': 'account-post:unload'
				}
			}
		}
	}
});